import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import {find} from 'lodash';
import classnames from "classnames";
import Button from '@material-ui/core/Button';
import Typography from "@material-ui/core/Typography";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import green from "@material-ui/core/colors/green";
import i18n from '../../i18n';

const shorten = (txt, max) => {
    if (txt && (txt.length > max)) {
        txt = txt.substring(0, max - 3) + '...';
    }
    return txt;
};

const NotificationPartial = ({classes, notifications}) => {
    const notification = find(notifications, n => !n.read_at);

    if (!notification) {
        return null;
    }

    const severity = notification.data['severity'] || 'info';
    let title = notification.data['title'];
    if (!title && !notification.data['requestor_id']) {
        title = i18n.get('house_attributes.costs.scanToBill.title');
    }

    return (
        <SnackbarContent
            className={classnames(classes.content, classes[severity])}
            aria-describedby="client-snackbar"
            message={(
                <span id="client-snackbar">
                    <Typography
                        color="inherit"
                        component="h1"
                        variant="h6"
                    >
                        {i18n.get('notification.alert.title')}
                    </Typography>
                    <Typography
                        color="inherit"
                        variant="subtitle1"
                    >
                        {i18n.get('notification.alert.message', {'title': shorten(title, 50)})}
                    </Typography>
                    {notification.data['subtitle'] && (
                        <Typography color="inherit" variant="subtitle2" component="span">
                            {shorten(notification.data['subtitle'], 150)}
                        </Typography>
                    )}
                </span>
            )}
            action={(
                <Button
                    component="a"
                    color="inherit"
                    href={`/notifications/${notification.id}`}
                >
                    {i18n.get('notification.alert.show_more')}
                </Button>
            )}
        />
    );
};

const styles = theme => ({
    content: {
        maxWidth: '100%',
    },
    success: {
        backgroundColor: green[600],
    },
    warning: {
        backgroundColor: theme.colors.iceBlue,
        color: theme.colors.primary,
        borderLeft: '6px solid ' + theme.colors.primary,
        borderRadius: 0,
        marginBottom: '0.5rem'
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.dark,
    },
    icon: {
        fontSize: 20,
        opacity: 0.9,
        marginRight: theme.spacing.unit,
    },
});

export default withStyles(styles)(NotificationPartial);
